import { render } from "./ButtonMain.vue?vue&type=template&id=4f797918&lang=true"
import script from "./ButtonMain.vue?vue&type=script&lang=js"
export * from "./ButtonMain.vue?vue&type=script&lang=js"

import "./ButtonMain.vue?vue&type=style&index=0&id=4f797918&lang=css"
script.render = render

export default script